import { apiResourceUrl } from "@ploy-lib/core";
import paramsToString, { BaseResource } from "./BaseResource";
import { SimpleResource } from "@rest-hooks/rest";

export interface ApplicationMortgageERegistration {
	readonly applicationId?: number;
	readonly applicationMortgageERegistrationId?: number;
	readonly documentYear?: number;
	readonly documentNumber?: number;
	readonly documentOffice?: string;
	readonly message?: string;
	readonly status?: string;
	readonly registrationDate?: string;
	readonly registrationTime?: string;
	readonly mortgageValue?: number;
	readonly expirationDate?: string;
}

export class ApplicationMortgageERegistrationResource
	extends BaseResource
	implements ApplicationMortgageERegistration
{
	readonly applicationId?: number = undefined;
	readonly applicationMortgageERegistrationId?: number = undefined;
	readonly documentYear?: number = undefined;
	readonly documentNumber?: number = undefined;
	readonly documentOffice?: string = undefined;
	readonly message?: string = undefined;
	readonly status?: string = undefined;
	readonly registrationDate?: string = undefined;
	readonly registrationTime?: string = undefined;
	readonly mortgageValue?: number = undefined;
	readonly expirationDate?: string = undefined;

	pk(parent?: any, key?: string): string | undefined {
		return `${this.applicationId?.toString()}`;
	}

	static url<T extends typeof SimpleResource>(
		this: T,
		urlParams: Readonly<Record<string, any>>
	) {
		const { applicationId, ...searchParams } = urlParams;

		const url = super.url(urlParams);

		return `${url}${paramsToString(searchParams)}`;
	}

	static urlRoot = apiResourceUrl("mortgage-eregistration");
}
